module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "11",
      "src": "images/common.jpg",
      "width": "433"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('p', {
    staticClass: "cont"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/pref01#pref01"
    }
  }, [_vm._v("Architects of the American Century")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part01#part01"
    }
  }, [_vm._v("One GATHERING")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1. World of Their Own/To the manner born")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2. Tap Days/“To run with the swift”")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03"
    }
  }, [_vm._v("3. Joint Ventures/Harriman and Lovett on Wall Street")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. World Courts/McCloy and Acheson before the bar")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. A Pretty Good Club/Kennan and Bohlen in the Foreign Service")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. On Active Service/Enlisting in a noble cause")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Heavenly Twins /McCloy and Lovett at the War Department")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Missions to Moscow/Harriman, Acheson, Bohlen and Kennan wrestle with a biting bear")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part02#part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two CREATION")])]), _vm._v(" "), _c('p', {
    staticClass: "conta"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Words of One Syllable/The education of Harry Truman")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Line down the Middle/Splitting Germany and the atom")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Blinding Dawn/Diplomacy in an atomic age")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Containment/Sensitive to the logic of force")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Order from Chaos/“Like apples in a barrel”")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. “Simple Honest Men”/The selling of the Marshall Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Crisis/“Will Russia move first?”")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. “A Different World”/Of Super bombs and primitives")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. War/“No weakness of purpose here”")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Nadir/Disaster at the Yalu")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Exile/The wilderness years")])]), _vm._v(" "), _c('p', {
    staticClass: "cont1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/part03#part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three WISE MEN")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Passing the Torch/“No, sir, my bearings are burnt out”")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Twilight Struggles/Reunion at the brink")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. LBJ’s Establishment/“I told the President he was wholly right”")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Judgment Days/Last Supper of the Wise Men")])]), _vm._v(" "), _c('p', {
    staticClass: "cont"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Legacy/“Never in such good company”")])]), _vm._v(" "), _c('p', {
    staticClass: "contc"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "contc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/insert",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "contc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/notes#notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "contc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/source#source",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "contc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee67910","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cont.vue
// module id = 69
// module chunks = 0